import React, {useEffect, useState} from "react";
import {getCategories} from "../../service/myProductService";

const Menu1 =()=>{

    const [items, setItem]= useState([]);
      const getDataCategories=()=>{
        getCategories().then((response)=>{
            if(+response.status === 200){
                setItem(response.message);
                window.localStorage.setItem('itemCate', JSON.stringify(response.message));
                window.localStorage.setItem('cateNode', true);

                var _uri_cate = [];
                response.message?.forEach(element => {
                    _uri_cate.push(element.url_key);
                    if(element.child?.length > 0){
                        element.child?.forEach(element1 => {
                            _uri_cate.push(element1.url_key);
                            if(element1.child.length > 0){
                                element1.child?.forEach(element2 => {
                                    _uri_cate.push(element2.url_key);
                                });
                            }
                        });
                    }
                });
                // window.localStorage.setItem('itemCateName', JSON.stringify(_uri_cate));
            }
        });
      }

    //   const loadDataBrand=()=>{
    //     getBrands().then((response)=>{
    //         if(+response.status === 200){
    //             var _uri_brand = [];
    //             response.message?.forEach(element => {
    //                 _uri_brand.push(element.url_key);
    //             });
    //             window.localStorage.setItem('itemUriBrand', JSON.stringify(_uri_brand));
    //         }
    //     });
    //   }

      useEffect(()=>{
        getDataCategories("","","");
      },[]);
    return(
        <div className="w-100 position-relative mt-3">
            <ul className="menu mx-auto text-center position-relative">
                {
                    items.slice(3,4).map((item, index)=>{
                        return <li key={index} className=""><a href={"/"+item.url_key+".html"} className=""><span>{item.name}</span></a>
                                {
                                     items.length ? (
                                            <ul className="menu__lever--two bg-danger w-100 bg-white position-absolute top-100 start-0 z-3 ">
                                                <div className="row row--maint w-100 m-0 ">
                                                {
                                                    item.child?.map((childNode,i)=>{
                                                    return  <div key={i} className="col-3">
                                                                <div className="text-start w-100">
                                                                    <div className="w-100 text-start position-relative">
                                                                        <li className="pt-4 pe-1">
                                                                            <a href={"/"+childNode.url_key+".html"} className="position-relative z-1" >
                                                                                <span>{childNode.name}</span>
                                                                                <div className="rand position-absolute bg-danger"></div>
                                                                            </a>
                                                                        </li>
                                                                        {
                                                                            childNode.child?.length>0 ?(
                                                                                <ul className="menu__lever--three">
                                                                                    {
                                                                                        childNode.child?.slice(0,5).map((childNode1,k)=>{
                                                                                        return  <li key={k}>
                                                                                            <a href={"/"+childNode1.url_key+".html"}>{childNode1.name}</a>
                                                                                            </li>
                                                                                        })
                                                                                    }
                                                                                    <li><a href="" className="text-danger"><span>Xem tất cả <i className="bi bi-chevron-right fs-5"></i></span></a></li>
                                                                                </ul>
                                                                            ):(null)
                                                                        }
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        })
                                                }
                                              </div></ul>
                                    ):(null)
                                }   
                            </li>
                        
                    })
                }

            </ul>
        </div>
    )

}

export default Menu1;